import { h, render, Component } from "preact";
import { translate } from "react-i18next";

const locale = {
  labelUsername: "Username",
  labelPassword: "Password",
  labelConfirm: "Confirm",
  labelEmail: "Email",
  labelRecovery: "Recovery Code",
  labelTwoFactor: "Two Factor Code",
  labelAuth: "Authentication Code",
  labelAge:
    'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
  labelSubscribe: "Send me Hi-Rez Studios news.",
  copyCantLogin: "Can't Login?",
  copyDivider: "or",
  copyServicesSignup: "Sign Up With:",
  copyServicesLogin: "Login With:",
  copyContactSupport: "If the above options were not able to assist you:",
  btnLogin: "Login",
  btnCreate: "Create",
  btnCreateFree: "Create A Free Account",
  btnSubmit: "Submit",
  btnGoogle: "Google",
  btnFacebook: "Facebook",
  btnBack: "Back",
  btnRecoverUsername: "Forgot Your Username?",
  btnRecoverPassword: "Forgot Your Password?",
  btnRecoverCode: "Use One Time Recovery Code",
  btnBackupEmail: "Use Backup Email to Login",
  btnContactSupport: "Contact Customer Support",
  smiteCopy: "Sign Up Now! Join 25+ Million Players Today",
  errorUsernameMissing: "A username is required to create an account.",
  panelCopyCantLogin:
    "There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.",
  panelCopyForgotUsername: "Enter in the email associated with your account to receive a reminder email.",
  panelCopyForgotPassword: "Enter in the email and username associated with your account to reset your password.",
  panelCopyRecoveryCode:
    "Enter in the username and one time recovery code (when you setup your two factor authentication) to login.",
  panelCopyBackupEmail:
    "Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.",
  panelCopyCreateGoogle:
    "A verified email address with Google is required to create an account. You will use your Google login to play.",
  panelCopyCreateFacebook:
    "A verified email address with Facebook is required to create an account. You will use your Facebook login to play.",
  panelCopyLoginThirdParty: "You will be logged in as:",
  forgotResponse: "Thank you, an email has been sent to the address on file.",
  noMasterAccount: "We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?",
};

// Input Component
// TODO: better response handling for 200/40* responses
// TODO: form validation, different method
// TODO: show password action?
// TODO: live username checking
// TODO: realtime error display under input fields
// TODO: cleanup inputs section and actions section
class Inputs extends Component {
  // TODO: trim this section down if cases are not needed
  constructInputs = (panel) => {
    switch (panel) {
      case "login":
        this.setState({ btnCopy: locale.btnLogin });
        this.setState({ panelCopy: null });
        break;
      case "create":
        this.setState({ btnCopy: locale.btnCreate });
        this.setState({ panelCopy: null });
        break;
      case "forgot-username":
        this.setState({ btnCopy: locale.btnSubmit });
        this.setState({ panelCopy: locale.panelCopyForgotUsername });
        break;
      case "forgot-password":
        this.setState({ btnCopy: locale.btnSubmit });
        this.setState({ panelCopy: locale.panelCopyForgotPassword });
        break;
      case "recovery-code":
        this.setState({ btnCopy: locale.btnSubmit });
        this.setState({ panelCopy: locale.panelCopyRecoveryCode });
        break;
      case "backup-email":
        this.setState({ btnCopy: locale.btnSubmit });
        this.setState({ panelCopy: locale.panelCopyBackupEmail });
        break;
      case "create-google":
        this.setState({ btnCopy: locale.btnCreate });
        this.setState({ panelCopy: locale.panelCopyCreateGoogle });
        break;
      case "create-facebook":
        this.setState({ btnCopy: locale.btnCreate });
        this.setState({ panelCopy: locale.panelCopyCreateFacebook });
        break;
      case "login-google":
        this.setState({ btnCopy: locale.labelConfirm });
        this.setState({ panelCopy: locale.panelCopyLoginThirdParty });
        break;
      case "login-facebook":
        this.setState({ btnCopy: locale.labelConfirm });
        this.setState({ panelCopy: locale.panelCopyLoginThirdParty });
        break;
      case "cant-login":
        this.setState({ panelCopy: locale.panelCopyCantLogin });
        break;
      default:
        this.setState({ btnCopy: locale.btnCreate });
        this.setState({ panelCopy: null });
    }
  };

  storeInputs = (e) => {
    switch (e.target.id) {
      case "username":
        this.setState({ username: e.target.value });
        break;
      case "password":
        this.setState({ password: e.target.value });
        break;
      case "confirm":
        this.setState({ confirm: e.target.value });
        break;
      case "email":
        this.setState({ email: e.target.value });
        break;
      case "recovery":
        this.setState({ recovery: e.target.value });
        break;
      case "authentication":
        this.setState({ authentication: e.target.value });
        break;
      case "age":
        this.setState({ age: e.target.checked });
        break;
      case "subscribe":
        this.setState({ subscribe: e.target.checked });
        break;
      case "twofactor":
        this.setState({ twofactor: e.target.value });
        break;
    }
  };

  // create cookie
  createCookie = (name, value, days) => {
    let expires;
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
    //document.cookie = name+"="+value+expires+";path=/";
  };

  // read cookie
  readCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };

  // erase cookie
  eraseCookie = (name) => {
    this.createCookie(name, "", -1);
  };

  validateEmail = (response, email) => {
    let emailValidation =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailValidation.test(String(email).toLowerCase()) === true) {
      this.submitForm(response);
    } else {
      this.setState({ resMessage: "Please enter a valid email address." });
    }
  };

  submitForm = (recaptcha) => {
    // TOOD: validate form before this process continues
    let method;
    let endpoint;
    let payload;
    let source = 13;
    let recapResponse = hcaptcha.getResponse();
    switch (this.state.panel) {
      case "login":
        method = "POST";
        endpoint = "loginDashboard";
        if (this.state.twofactor !== undefined) {
          payload = `{"username":"${this.state.username}","password":"${this.state.password}","code":"${this.state.twofactor}","recaptcha": "${recapResponse}"}`;
        } else {
          payload = `{"username":"${this.state.username}","password":"${this.state.password}","recaptcha": "${recapResponse}"}`;
        }
        break;
      case "create":
        method = "POST";
        endpoint = "create";
        payload = `{"username":"${this.state.username}","password":"${this.state.password}","confirmPassword":"${this.state.confirm}","email":"${this.state.email}","over13":"${this.state.age}","subscribe":"${this.state.subscribe}","recaptcha": "${recapResponse}"}`;
        break;
      case "forgot-username":
        method = "POST";
        endpoint = "sendUsername";
        payload = `{"email":"${this.state.email}"}`;
        break;
      case "forgot-password":
        method = "POST";
        endpoint = "resetPassword";
        payload = `{"username":"${this.state.username}","email":"${this.state.email}"}`;
        break;
      case "recovery-code":
        method = "POST";
        endpoint = "auth/singleUseCodeLogin";
        payload = `username=${this.state.username}&singleUseCode=${this.state.recovery}`;
        break;
      case "backup-email":
        method = "POST";
        endpoint = "auth/login";
        payload = `username=${this.state.username}&password=${this.state.password}&source=${source}&useBackupEmail=true`;
        break;
      case "login-google":
        method = "POST";
        endpoint = "loginGoogleUser";
        payload = `{"token":"${this.props.thirdPartyToken}","clientType":"0"}`;
        break;
      case "login-facebook":
        method = "POST";
        endpoint = "loginFacebookUser";
        payload = `{"token":"${this.props.thirdPartyToken}","clientType":"0"}`;
        break;
    }
    if (this.state.passwordConfirm === undefined) {
      this.setState({ disableSubmit: true });
      fetch(`https://api.hirezstudios.com/acct/${endpoint}`, {
        method: `${method}`,
        headers: {
          "Content-Type": "application/json",
        },
        body: `${payload}`,
      })
        .then((response) => response.json())
        .then((response) => {
          hcaptcha.reset();
          this.setState({ disableSubmit: false });
          if (response.errors) {
            this.setState({ resMessage: response.errors[0] });
          } else if (response.webToken) {
            // set cookie for web token
            this.createCookie("HZAcctWebToken", response.webToken, 30);
            this.createCookie("HZAcctTokenExp", response.expiration, 30);
            this.createCookie("HZAcctUsername", response.user, 30);
            this.createCookie("HZRegion", response.region, 30);
            this.createCookie("HZAccountId", response.accountId, 30);
            window.location.reload();
          } else if (
            this.state.panel === "forgot-password" ||
            (this.state.panel === "forgot-username" && response.statusCode === 200)
          ) {
            this.setState({
              resMessage: undefined,
              panelCopy: locale.forgotResponse,
              panel: "login",
            });
            this.navController(this.state.panel);
          } else if (response.statusCode === 400) {
            this.setState({ resMessage: "Please check your information and try again." });
          } else if (response.statusCode === 401) {
            hcaptcha.reset();
            this.setState({ resMessage: "Validation failed. Please try again." });
          } else if (response.statusCode === 403) {
            this.setState({ showTwoFactor: true });
          } else {
            this.setState({ resMessage: undefined });
          }
        });
    }
  };

  getRecaptchaToken = () => {
    let token = hcaptcha.getResponse();
    if (!token) {
      setTimeout(this.getRecaptchaToken, 100);
      return;
    }
    if (this.state.email !== undefined) {
      this.validateEmail(token, this.state.email);
    } else {
      this.submitForm(token);
    }
  };

  recaptchaVerify = (e) => {
    e.preventDefault();
    hcaptcha.execute();
    this.getRecaptchaToken();
  };

  constructor(props) {
    super(props);
    this.state = {
      panel: this.props.panel,
      showLoading: false,
      btnCopy: null,
      referral: this.props.referral,
      showTwoFactor: false,
      disableSubmit: false,
    };
  }

  componentWillMount() {
    this.constructInputs(this.state.panel);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ panel: nextProps.panel });
    this.constructInputs(this.state.panel);
    this.setState({ username: undefined });
    this.setState({ password: undefined });
    this.setState({ confirm: undefined });
    this.setState({ email: undefined });
    this.setState({ recovery: undefined });
    this.setState({ twofactor: undefined });
    this.setState({ authentication: undefined });
    this.setState({ age: undefined });
    this.setState({ subscribe: undefined });
    this.setState({ resMessage: undefined });
  }

  render() {
    const { t } = this.props;
    return (
      <div className={`inputs-wrapper ${this.state.panel}`}>
        {this.state.panelCopy && <div className="panel-copy">{t(this.state.panelCopy)}</div>}
        {this.props.thirdPartyEmail !== null && (this.state.panel === "login-google" || "login-facebook") && (
          <div className="third-party-email">{this.props.thirdPartyEmail}</div>
        )}
        {this.state.resMessage && <div className="response-message">{t(this.state.resMessage)}</div>}
        <div className="username-wrapper">
          <label htmlFor="username">{t(locale.labelUsername)}</label>
          <input type="text" id="username" onInput={this.storeInputs} value={this.state.username} />
        </div>
        <div className="password-wrapper">
          <label htmlFor="username">{t(locale.labelPassword)}</label>
          <input type="password" id="password" onInput={this.storeInputs} value={this.state.password} />
        </div>
        <div className="confirm-wrapper">
          <label htmlFor="confirm">{t(locale.labelConfirm)}</label>
          <input type="password" id="confirm" onInput={this.storeInputs} value={this.state.confirm} />
        </div>
        <div className="password-wrapper">
          <input type="hidden" id="passwordConfirm" onInput={this.storeInputs} value={this.state.passwordConfirm} />
        </div>
        <div className="email-wrapper">
          <label htmlFor="email">{t(locale.labelEmail)}</label>
          <input type="text" id="email" onInput={this.storeInputs} value={this.state.email} />
        </div>
        <div className="recovery-wrapper">
          <label htmlFor="recovery">{t(locale.labelRecovery)}</label>
          <input type="text" id="recovery" onInput={this.storeInputs} value={this.state.recovery} />
        </div>
        {this.state.showTwoFactor === true && (
          <div className="twofactor-wrapper">
            <label htmlFor="twofactor">{t(locale.labelTwoFactor)}</label>
            <input type="text" id="twofactor" onInput={this.storeInputs} value={this.state.twofactor} />
          </div>
        )}
        <div className="authentication-wrapper">
          <label htmlFor="authentication">{t(locale.labelAuth)}</label>
          <input type="text" id="authentication" onInput={this.storeInputs} value={this.state.authentication} />
        </div>
        <div className="age-wrapper">
          <input type="checkbox" id="age" onInput={this.storeInputs} value={this.state.age} />
          <label htmlFor="age" dangerouslySetInnerHTML={{ __html: t(locale.labelAge) }} />
        </div>
        <div className="subscribe-wrapper">
          <input type="checkbox" id="subscribe" onInput={this.storeInputs} value={this.state.subscribe} />
          <label htmlFor="subscribe">{t(locale.labelSubscribe)}</label>
        </div>
        <input type="hidden" id="referral" value={this.state.referral} />
        <div className="h-captcha" data-sitekey="a19bf4f8-9fcb-43d6-be97-ff5623f9621c" data-size="invisible"></div>
        <div className="actions-wrapper">
          <div className="submit">
            <input
              type="submit"
              onClick={this.recaptchaVerify}
              value={t(this.state.btnCopy)}
              className={`login-btn ${this.state.disableSubmit ? "disable-submit" : ""}`}
            />
            {this.state.panel === "login" && (
              <div className="create-acct-assist">
                <a class="cant-login" onClick={() => this.props.callback("cant-login", this.state.panel)}>
                  {this.state.panel === "login" ? t(locale.copyCantLogin) : ""}
                </a>
                <a class="create-free" onClick={() => this.props.callback("create", this.state.panel)}>
                  {t(locale.btnCreateFree)}
                </a>
              </div>
            )}
          </div>
          <div className="loading" />
        </div>
        <div className="cant-login-wrapper">
          <a onClick={() => this.props.callback("forgot-username")}>{t(locale.btnRecoverUsername)}</a>
          <a onClick={() => this.props.callback("forgot-password")}>{t(locale.btnRecoverPassword)}</a>
          <div className="divider">{t(locale.copyDivider)}</div>
          <a href="https://support.hirezstudios.com/" target="_blank">
            {t(locale.btnContactSupport)}
          </a>
        </div>
      </div>
    );
  }
}

export default translate(["common"], { withRef: true })(Inputs);



// WEBPACK FOOTER //
// ./components/LoginPanelInputs.js